import {makeAutoObservable} from "mobx";
import {getHistoryRequest} from "../requests";


export class HistoryStore {

    history = []
    loading = false;
    page = 1;
    totalPages = 0
    pageSize = 10

    constructor(root) {
        this.root = root;
        makeAutoObservable(this);
    }

    setPage(page) {
        this.page = page;
        this.loadHistory();
    }

    setPageSize(pageSize) {
        this.pageSize = pageSize;
        this.loadHistory();
    }

    async loadHistory() {
        this.loading = true;
        const data = await getHistoryRequest(this.page, this.pageSize);
        this.history = data.results;
        this.totalPages = data.count;
        this.loading = false;
    }
}
